export const GET_APPROVAL_DOCS_REQUESTED = 'GET_APPROVAL_DOCS_REQUESTED';
export const GET_APPROVAL_DOCS_COMPLETED = 'GET_APPROVAL_DOCS_COMPLETED';
export const GET_APPROVAL_DOCS_FAILED = 'GET_APPROVAL_DOCS_FAILED';
export const GET_APPROVAL_DOCS_ABORTED = 'GET_APPROVAL_DOCS_ABORTED';

export const SET_CONTACT_APPROVAL_DOC_MARKED_ABORTED =
  'SET_CONTACT_APPROVAL_DOC_MARKED_ABORTED';
export const SET_CONTACT_APPROVAL_DOC_MARKED_REQUESTED =
  'SET_CONTACT_APPROVAL_DOC_MARKED_REQUESTED';
export const SET_CONTACT_APPROVAL_DOC_MARKED_COMPLETED =
  'SET_CONTACT_APPROVAL_DOC_MARKED_COMPLETED';
export const SET_CONTACT_APPROVAL_DOC_MARKED_FAILED =
  'SET_CONTACT_APPROVAL_DOC_MARKED_FAILED';

export const GET_ASSIGNED_APPROVAL_DOCS_REQUESTED =
  'GET_ASSIGNED_APPROVAL_DOCS_REQUESTED';
export const GET_ASSIGNED_APPROVAL_DOCS_COMPLETED =
  'GET_ASSIGNED_APPROVAL_DOCS_COMPLETED';
export const GET_ASSIGNED_APPROVAL_DOCS_FAILED =
  'GET_ASSIGNED_APPROVAL_DOCS_FAILED';

export const DOWNLOAD_ASSIGNED_APPROVAL_DOCS_REQUESTED =
  'DOWNLOAD_ASSIGNED_APPROVAL_DOCS_REQUESTED';
export const DOWNLOAD_ASSIGNED_APPROVAL_DOCS_COMPLETED =
  'DOWNLOAD_ASSIGNED_APPROVAL_DOCS_COMPLETED';
export const DOWNLOAD_ASSIGNED_APPROVAL_DOCS_FAILED =
  'DOWNLOAD_ASSIGNED_APPROVAL_DOCS_FAILED';

export const SET_SIGNED_APPROVAL_DOC_REQUESTED =
  'SET_SIGNED_APPROVAL_DOC_REQUESTED';
export const SET_SIGNED_APPROVAL_DOC_COMPLETED =
  'SET_SIGNED_APPROVAL_DOC_COMPLETED';
export const SET_SIGNED_APPROVAL_DOC_FAILED = 'SET_SIGNED_APPROVAL_DOC_FAILED';

export const CLEAR_APPROVAL_DOC = 'CLEAR_APPROVAL_DOC';

export const SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED =
  'SET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED';
export const SET_ACTIONAPPROVALDOCID_ROUTE_ABORTED =
  'SET_ACTIONAPPROVALDOCID_ROUTE_ABORTED';
export const SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED =
  'SET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED';
export const SET_ACTIONAPPROVALDOCID_ROUTE_FAILED =
  'SET_ACTIONAPPROVALDOCID_ROUTE_FAILED';

export const RESET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED =
  'RESET_ACTIONAPPROVALDOCID_ROUTE_REQUESTED';
export const RESET_ACTIONAPPROVALDOCID_ROUTE_ABORTED =
  'RESET_ACTIONAPPROVALDOCID_ROUTE_ABORTED';
export const RESET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED =
  'RESET_ACTIONAPPROVALDOCID_ROUTE_COMPLETED';
export const RESET_ACTIONAPPROVALDOCID_ROUTE_FAILED =
  'RESET_ACTIONAPPROVALDOCID_ROUTE_FAILED';
